module.exports = __webpack_public_path__ + "img/img_futa_rainbow.5dcedf4d.png";